export default {
  SET_PUSH_HISTORY(state, data) {
    state.pushHistory = data
  },

  DELETE_PUSH(state, deletedPush){
    state.pushHistory.data.content = state.pushHistory.data.content.filter((push) => push.id !== deletedPush.id)
  },
}
